
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';

interface ScheduleUploadPorductsContentToShopifytRequest {
    id: string,
}



const scheduleUploadPorductsContentToShopify = async (id: string): Promise<null> => {
    const scheduleUploadPorductsContentToShopify = httpsCallable<ScheduleUploadPorductsContentToShopifytRequest, null>(functions, 'handle_schedule_upload_products_content_to_shopify');
    const result = await scheduleUploadPorductsContentToShopify({ id });
    return null;
};

export { scheduleUploadPorductsContentToShopify };